export const formatPhoneNumber = (v: string | null) => {
  if (!v) return "";
  const v1 = String(v).slice(0, 3);
  const v2 = String(v).slice(3, 7);
  const v3 = String(v).slice(7, 11);
  return `${v1}-${v2}-${v3}`;
};
